import { Component, OnInit, AfterViewInit, ElementRef, Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Resolve, Router } from '@angular/router';
import { getTitle, getDescription } from '../../lib/helpers';
import { CatalogItem } from '../../catalog/catalog.service';
import { CompareService } from '../compare.service';
import { NotificationService } from '../../notification.service';
import { BreadCrumbsService } from '../../breadcrumbs.service';
import { RestComponent } from '../../lib/RestComponent';
import $ from '../../lib/jquery';

@Component({
  selector: 'compare-page',
  templateUrl: './compare-page.component.html',
  styleUrls: ['./compare-page.component.less']
})
export class ComparePageComponent extends RestComponent implements OnInit, AfterViewInit {
  lists: string[] = [];
  items: CatalogItem[] = [];
  filterList: string = null;
  compareMode: string = 'all';

  constructor(
    private el: ElementRef,
    private route: ActivatedRoute,
    private compareService: CompareService,
    private titleService: Title,
    private metaService: Meta,
    private breadCrumbsService: BreadCrumbsService,
    private notificationService: NotificationService,
  ) {
    super();
    this.titleService.setTitle(getTitle('Сравнение товаров'));
    this.metaService.updateTag({name: 'description', content: getDescription('Сравнение товаров')});

    this.breadCrumbsService.create([{
      name: 'Сравнение товаров',
      color: 'general-primary'
    }]);
  }

  public ngOnInit() {
    this.route.data.subscribe((data: {data: {lists: string[], items: CatalogItem[]}}) => {
      this.lists = data.data.lists;
      this.items = data.data.items;
      if (this.lists.length) this.filterList = this.lists[0];
    });
  }

  public ngAfterViewInit() {
    this.fastenHeadFixed();
  }

  private fastenHeadFixed() {
    if (typeof window === 'undefined') return;
    if (this.items.length === 0) return;

    const headFixed = $(this.el.nativeElement).find('#CompareHeadFixed');
    const heightHead = headFixed.children().height();
    const headFixedParent = headFixed.parent();
    const $window = $(window);

    $window.on('scroll', () => {
      if ($window.scrollTop() > 300) {
        headFixed.css('height', heightHead + 'px');
      } else {
        headFixed.css('height', '0px');
      }

      if ($window.scrollTop() > (headFixedParent.offset().top) &&
        (headFixedParent.height() + headFixedParent.position().top - 160) > ($window.scrollTop() + headFixed.height())) {
        headFixed.animate(
          { top: ($window.scrollTop() - headFixedParent.offset().top) + 70 + 'px' },
          { queue: false, duration: 0 }
        );
      } else if ($window.scrollTop() < (headFixedParent.offset().top)) {
        headFixed.animate({ top: '0px' }, { queue: false, duration: 0 });
      }
    });
  }

  public async changeList() {
    this.loadingState = true;
    try {
      const items = await this.compareService.get(this.filterList);
      this.items = items.items;

      this.fastenHeadFixed();

      this.loadingState = false;
      return this.items;
    } catch (err) {
      this.error = true;
      this.errorMessage = err;
      this.loadingState = false;
    }
  }

  public removeList() {}

  public isEqualProp(propIndex: number): boolean {
    const arrMatch: string[] = [];
    this.items.forEach((item) => {
      arrMatch.push(item.PROPERTIES[propIndex].VALUE);
    });

    for (let i = 0; i < arrMatch.length; i++) {
      if (arrMatch[0] !== arrMatch[i]) break;
      if (i === arrMatch.length - 1) return true;
    }
    return false;
  }

  public changeMode(compareMode: string) {
    this.compareMode = compareMode;
  }

  public async removeFromCompare(item: CatalogItem, index: number) {
    this.loadingState = true;
    try {
      const res = await this.compareService.delete(item.ID);
      this.items.splice(index, 1);
      this.compareService.updateCompare();
      this.notificationService.show({
        message: res.message,
        status: 'success'
      });
      this.loadingState = false;
    } catch (e) {
      this.notificationService.show({
        message: e.message,
        status: 'danger'
      });
      this.loadingState = false;
    }
  }
}

@Injectable()
export class CompareResolver implements Resolve<{
  lists: string[],
  items: CatalogItem[]
}> {
  constructor(
    private compareService: CompareService,
    private notificationService: NotificationService,
    private router: Router
  ) {}

  public async resolve(): Promise<{
    lists: string[],
    items: CatalogItem[]
  }> {
    const res: {
      lists: string[],
      items: CatalogItem[]
    } = {lists: null, items: null};

    try {
      res.items = await this.compareService.get();

      res.lists = await this.compareService.getLists();

      return res;
    } catch (e) {
      this.notificationService.show({
        message: e.message,
        status: 'danger'
      });
      this.router.navigate(['/']);
      return null;
    }
  }
}
